import { useEffect, useState } from "react";
import "./TicketModal.scss";
import Ticket from "../../assets/images/ticket.png";
import PaystackPop from "@paystack/inline-js";
import PaymentForm from "../PaymentForm/PaymentForm";
import { MdClose } from "react-icons/md";

// https://script.google.com/macros/s/AKfycbxg6MaRNASkrwueIEYNHG5cfyVbNvY_brnm008RL6rj4D8AWz3zeDFfAlIyVy4nW0sk/exec
const initialFormData = {
  Name: "",
  Email: "",
  Phone: "",
  TicketCategory: "",
  Amount: 0,
  Quantity: "",
};

const TicketModal = ({ onClose, showModal }) => {
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const payWithPayStack = () => {
    const payStack = new PaystackPop();

    payStack.newTransaction({
      key: "pk_live_b9dfddfe7300fdec7796b0eab3d714dbe47b0a35",
      // key: "pk_test_515ddffee4c29e5a5b59ea9296f802c49c85c3ab",
      email: formData.Email,
      amount: formData.Amount * 100,
      metadata: {
        custom_fields: [
          {
            display_name: "Name",
            variable_name: "name",
            value: formData.Name,
          },

          {
            display_name: "Mobile Number",
            variable_name: "mobile_number",
            value: formData.Phone,
          },

          {
            display_name: "Ticket Category",
            variable_name: "ticket_category",
            value: formData.TicketCategory,
          },

          {
            display_name: "Quantity",
            variable_name: "quantity",
            value: formData.Quantity,
          },
        ],
      },

      onSuccess: (transaction) => {
        console.log(transaction);
        let message =
          "Transaction was successful🎉 You will get a mail from us soon, cheer!";
        alert(message);
      },

      onCancel: () => {
        window.confirm("Are you sure you want to cancel the transaction 😪");
      },

      onClose: () =>
        window.confirm("Are you sure you want to close the transaction 😪"),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(
      "https://script.google.com/macros/s/AKfycbxg6MaRNASkrwueIEYNHG5cfyVbNvY_brnm008RL6rj4D8AWz3zeDFfAlIyVy4nW0sk/exec",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
    setFormData(initialFormData);
    payWithPayStack();
  };

  useEffect(() => {
    const calculateAmount = () => {
      let newAmount = 0;

      switch (formData.TicketCategory) {
        case "regular":
          newAmount = 2000 + 80; // Add Regular charge
          break;
        case "vanguard":
          newAmount = 5000 + 175; // Add Vanguard charge
          break;
        case "standard":
          newAmount = 7000 + 205; // Add Standard charge
          break;
        case "premium":
          newAmount = 10000 + 250; // Add Premium charge
          break;
        case "donor":
          newAmount = 50000 + 850; // Add Donor charge
          break;
        default:
          newAmount = 0;
      }

      setFormData((prevData) => ({ ...prevData, Amount: newAmount }));
    };

    calculateAmount();
  }, [formData.TicketCategory]);

  useEffect(() => {
    const updateAmount = () => {
      const newAmount =
        parseInt(formData.Amount, 10) * parseInt(formData.Quantity, 10);
      setFormData((prevData) => ({ ...prevData, Amount: newAmount }));
    };

    updateAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.Quantity]);

  useEffect(() => {
    // Add event listeners for clicking on the overlay and disabling scrolling

    const handleOverlayClick = (event) => {
      if (event.target.classList.contains("ticketModal-overlay")) {
        onClose();
      }
    };

    const handleScroll = () => {
      showModal
        ? (document.body.style.overflow = "hidden")
        : (document.body.style.overflow = "");
    };

    window.addEventListener("click", handleOverlayClick);
    window.addEventListener("scroll", handleScroll);
    return () => {
      // Clean up event listeners on unmount
      window.removeEventListener("click", handleOverlayClick);
      window.removeEventListener("scroll", handleScroll);
      document.body.style.overflow = "";
    };
  }, [onClose, showModal]);

  return (
    <section
      className={`${
        showModal ? "ticketModal-overlay show-modal" : "ticketModal-overlay"
      }`}
    >
      <article className="ticketModal__container container">
        <div className="ticketModal__container--contents">
          <figure className="ticketModal__container--contents-image">
            <img src={Ticket} alt="theme" />
          </figure>

          <div className="ticketModal__container--contents-form">
            <PaymentForm
              formData={formData}
              onChange={handleChange}
              onSubmit={handleSubmit}
            />
          </div>

          <button className="ticketModal__close" onClick={onClose}>
            <MdClose />
          </button>
        </div>
      </article>
    </section>
  );
};

export default TicketModal;
